module.exports = __webpack_public_path__ + "static/media/staff.167bd772.png";